<template>
  <div class="part">
    <p class="label input-filter-label">
      {{ $lang.messages.uploadAttachment }}
    </p>

    <div
      class="attachment upload-attachments"
      v-for="attachment in attachments"
      :key="attachment.attachmentGuid">
      <span class="document">
        <f-p-documents :type="attachment.fileName.split('.').pop()"></f-p-documents>
        <p :title="attachment.fileName">{{ attachment.fileName }}</p>
      </span>

      <span class="download delete-ico" @click="deleteUploadAttachment(attachment.fileName)">
        <img src="@/assets/images/payments/delete_ico.png" />
      </span>
    </div>

    <div
        class="attachment"
        v-for="(attachment, index) in uploadedAttachments"
        :key="`att-${index}`">
      <span class="document">
        <f-p-documents :type="attachment.extension.toLowerCase()"></f-p-documents>
        <p :title="attachment.fileName + '.' + attachment.extension">{{ attachment.fileName }}.{{ attachment.extension }}</p>
      </span>

      <span class="download delete-ico" @click="deleteAttachment(attachment.attachmentGuid)">
        <img src="@/assets/images/payments/delete_ico.png" />
      </span>
    </div>

    <base64-upload
      @change="onChangeFile"
      :expense="true"
      :numberOfFiles="numberOfFiles"
      :class="{'upload' : actionType === 'edit'}"
      ref="base64Upload"
      :key="rerender">
    </base64-upload>
  </div>
</template>

<script>
  import Base64Upload from '@/components/common/Base64Upload';
  import FPDocuments from '../FPDocuments';

  export default {
    name: "FPInputUpload",
    components: {
      Base64Upload,
      'f-p-documents': FPDocuments
    },
    props: {
      actionType: {
        type: String,
        required: true
      },
      attachments: {
        type: [Array, Object],
        required: true
      },
      uploadedAttachments: {
        type: [Array, Object],
        required: true
      }
    },
    data() {
      return {
        rerender: 0
      }
    },
    computed: {
      numberOfFiles() {
        if (this.actionType === 'add') {
          return this.attachments.length;
        } else {
          return this.attachments.length + this.uploadedAttachments.length;
        }
      }
    },
    methods: {
      deleteUploadAttachment (val) {
        this.$refs.base64Upload.deleteAttachment(val)
        this.$emit('deleteUploadAttachment', val)
        this.rerender++
      },
      deleteAttachment (val) {
        this.$emit('deleteAttachment', val)
      },
      onChangeFile (file) {
        this.$emit('onChangeFile', file)
      }
    }
  }
</script>
